module.exports = __webpack_public_path__ + "img/edit.fb94a763.svg";